import APIS from "../../http/apis";
import GetUtils from "../../utils/utils";
import { Toast } from "vant";


const state = () => ({
    userInfoData: {}, //用户个人直播数据
    footerList: [], //底部list
    // token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    memberId: null,  // id
    chatData: null, // 直播间数据
    userActiveIndex: 0,  // 直播间数据
    listGift: [],    // 礼物
    isGiftsEffects: 0,  // 设置礼物id
    moneyRefresh: 0,   //  余额更新
    watchFun: false,  // 是否调用过一次初始化视频
    isEffects: true,  // 开关特性
    isLivePage: true,  // 全屏开关
    giftTop3: [],   // 排行榜
    carEffectList: [], // vip座驾特效
    showVideoCover: true,//是否显示cover封面
    isLoading: true, //是否显示loading
    liveDataList: [], //直播列表数据
    isShowChatBox: false, //是否显示聊天输入框
    isLoginChatSuccess: false, //是否已登录聊天室
    mainSwitch: true,  //特效总开关
    isShowEffect: true, //清屏特效展示
    isShowSetInfo: false, //是否显示充值组件
    previewConfig: {}, //直播预览图
    selectValue: '', //选中二级页面
    isShowGirl: false, //是否展示首页美女
    isShowLoad: false, //是否展示充值弹出页面
    timerRecord: 0, //倒计时记录秒数
    openMp3: false,
    adverList: [], //广告数组
    homeAdverList: [], //首页弹窗广告数组
    liveAdverList: [], //直播间弹窗广告数组
    remandList: [], //推荐游戏列表
    channel: '', //渠道
    video_domain: '', //预览视频CDN
    scSwitch: true, //全屏开关
    directLive: false, //是否来自直播入口
    isLandscape: false, // 是否处于横屏模式（用于 ChatBox 等挂载到 landscape-ui-overlay）
    wasLandscapeBeforeChat: false, // 横屏下为输入临时切竖屏，关聊天框后需恢复横屏
    enterFrom: '', // URL 参数 enterFrom，为 'offical' 时不展示横屏按钮
    isMatchLive: false, //是否来自匹配入口
});

const mutations = {
    SET_USER_DATA(state, value) {
        state.userInfoData = value;
    },
    M_UPDATA_FOOTER(state, val) {
        state.footerList = val
    },
    M_TOKEN(state, val) {
        state.token = val
    },
    SET_MEMBER_ID(state, value) {
        state.memberId = value;
    },
    M_CHAT_DATA(store, payload) {
        store.chatData = payload
    },
    M_USER_ACTIVE_INDEX(store, payload) {
        store.userActiveIndex = payload
    },
    SET_LIST_GIFT(state, value) {
        state.listGift = value;
    },
    SET_GIFTS_EFFECTS(state, value) {
        state.isGiftsEffects = value;
    },
    SET_MONEY_REFRESH(state, value) {
        state.moneyRefresh = value;
    },
    SET_WATCH_FUN(state, bool) {
        state.watchFun = bool;
    },
    SET_IS_EFFECTS(state, value) {
        state.isEffects = value;
    },
    SET_IS_LIVEPAGE(state, value) {
        state.isLivePage = value;
    },
    SET_GIFT_TOP3(state, value) {
        state.giftTop3 = value;
    },
    SET_CAR_EFFECTLIST(state, value) {
        state.carEffectList = value;
    },
    SET_SHOWVIDEOCOVER(state, bool) {
        state.showVideoCover = bool;
    },
    SET_SHOW_LOADING(state, bool) {
        state.isLoading = bool
    },
    SET_LIVE_DATA_LIST(state, arr) {
        state.liveDataList = arr;
    },
    CLEAR_LIVE_DATA_LIST(state, value) {
        state.liveDataList = [];
    },
    SET_CHAT_BOX_SHOW(state, bool) {
        state.isShowChatBox = bool
    },
    SET_LANDSCAPE(state, bool) {
        state.isLandscape = !!bool
    },
    SET_WAS_LANDSCAPE_BEFORE_CHAT(state, bool) {
        state.wasLandscapeBeforeChat = !!bool
    },
    SET_ENTER_FROM(state, val) {
        const raw = val != null ? String(val) : ''
        state.enterFrom = raw.trim().replace(/^['"]+|['"]+$/g, '')
    },
    SET_IS_LOGIN_CHAT(state, bool) {
        state.isLoginChatSuccess = bool
    },
    SET_MAIN_SWITCH(state, bool) {
        state.mainSwitch = bool
        localStorage.setItem("mainSwitch", bool)
    },
    SET_SHOW_EFFCET(state, bool) {
        state.isShowEffect = bool
    },
    SET_SHOW_SET(state, bool) {
        state.isShowSetInfo = bool
    },
    SET_PREVIEW_CONFIG(state, obj) {
        state.previewConfig = obj
    },
    SET_SELECT_VALUE(state, value) {
        state.selectValue = value
    },
    CLEAR_SELECT_VALUE(state) {
        state.selectValue = ''
    },
    SET_DIALOG_POP(state, value) {
        state.isShowGirl = value
    },
    SET_SHOW_LOAD(state, value) {
        state.isShowLoad = value
    },
    SET_TIMER_RECORD(state, value) {
        state.timerRecord = value
    },
    SET_OPEN_MP3(state, bool) {
        state.openMp3 = bool
    },
    SET_ADVER_LIST(state, arr) {
        state.adverList = arr
    },
    SET_HOME_ADVER_LIST(state, arr) {
        state.homeAdverList = arr
    },
    SET_LIVE_ADVER_LIST(state, arr) {
        state.liveAdverList = arr
    },
    SET_VIDEO_DOMAIN(state, value) {
        state.video_domain = value
    },
    SET_REMAND_LIST(state, arr) {
        state.remandList = arr
    },
    SET_CHANNEL_STATE(state, value) {
        state.channel = value
    },
    SET_SC_SWITCH(state, bool) {
        state.scSwitch = bool
    },
    SET_DIRECT_LIVE(state, bool) {
        state.directLive = bool
    },
    SET_IS_MATCH_LIVE(state, bool) {
        state.isMatchLive = bool
    },
};

const actions = {
    // 排行榜
    getGiftTop3Fn({ commit }, params) {
        return APIS.getLiveRank(params)
            .then(res => {
                if (res) {
                    const { code, data } = res;
                    if (code == 200) {
                        commit('SET_GIFT_TOP3', data || []);
                    }
                    return res;
                }
            });
    },
    // vip座驾特效
    getCarEffectListFn({ commit }, params) {
        return APIS.getCarEffectList(params)
            .then(res => {
                if (res) {
                    const { code, data } = res;
                    if (code == '1') {
                        commit('SET_CAR_EFFECTLIST', data.listGift || []);
                    }
                    else {
                        Toast.fail(res.msg);
                    }
                    return res;
                }
            });
    },
    // 关闭特效
    getIsEffectsFn({ commit }, params) {
        commit('SET_IS_EFFECTS', params);
    },
    // 全屏开关
    getIsLivePageFn({ commit }, params) {
        commit('SET_IS_LIVEPAGE', params);
    },
    getPreviewConfig({ commit }, params) { //获取直播预览配置
        APIS.postGets(params).then((res) => {
            if(res.code == 200 && res.data?.data?.live_closed_img?.value) {
                commit('SET_PREVIEW_CONFIG', res.data?.data?.live_closed_img?.value);
            }
        })
    },
    getVideo_domain({ commit }, params) { //获取直播预览配置
        APIS.postGets(params).then((res) => {
            if(res.code == 200 && res.data?.playback_video_domain?.value) {
                const arr = res.data?.playback_video_domain?.value.split(',')
                GetUtils.speedTest(arr).then(fastest => { 
                    commit('SET_VIDEO_DOMAIN', fastest)
                });
            }
        })
    },
    postGetAdver({ commit }, params) { //获取首页广告配置
        APIS.postGetAdver(params).then((res) => {
            if(res.code == 200 && res.data.list && res.data.list.length > 0) {
               commit('SET_ADVER_LIST', res.data.list)
            }
        })
    },
    postGetHomeAdver({ commit }, params) { //获取首页弹窗广告配置
        APIS.postGetAdver(params).then((res) => {
            if(res.code == 200 && res.data.list && res.data.list.length > 0) {
               commit('SET_HOME_ADVER_LIST', res.data.list)
            }
        })
    },
    postGetLiveAdver({ commit }, params) { //获取直播间弹窗广告配置
        APIS.postGetAdver(params).then((res) => {
            if(res.code == 200 && res.data.list && res.data.list.length > 0) {
               commit('SET_LIVE_ADVER_LIST', res.data.list)
            }
        })
    },
    postGetAdList({ commit }, params) { //获取推荐游戏
        APIS.postGetAdver(params).then((res) => {
            if(res.code == 200 && res.data.list && res.data.list.length > 0) {
               commit('SET_REMAND_LIST', res.data.list)
            }
        })
    },
    postClick(params) { //福袋&&广告报表
        APIS.postClick(params)
    },
};

// getters
const getters = {
    M_FooterList(state) {
        return state.footerList
    },
    M_token(state) {
        return state.token
    },
    M_USER_DATA(state) {
        return state.userInfoData
    },
    M_chatData(state) {
        return state.chatData
    },
    M_userActiveIndex(state) {
        return state.userActiveIndex
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
